import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"mb-4",attrs:{"outlined":""}},[_c(VCardText,{staticClass:"pb-0 grey--text text--darken-4"},[_c('p',{staticClass:"mb-0"},[_vm._v(" Cliquez ci-dessous pour regarder l'état de toutes vos cantines et les actions à lancer pour chacune. ")])]),_c(VCardText,{},[_c(VBtn,{attrs:{"to":{ name: 'ActionPlan' },"color":"primary"}},[_vm._v("Mes actions")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }